import {getAuth, signOut} from 'firebase/auth'
import React, {useEffect, useState} from 'react'
import {removeCurrentUserAction, setCurrentUserAction} from './common/auth/authenticationSlice'
import {useVerifyAuthLazyQuery} from './generated/graphql'
import {useAppDispatch} from './store'

interface Props {}

export const AuthenticationProvider: React.FC<React.PropsWithChildren<Props>> = ({children}) => {
  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState(true)

  const [verifyAuth] = useVerifyAuthLazyQuery({fetchPolicy: 'network-only'})

  useEffect(() => {
    const unsubscribe = getAuth().onAuthStateChanged(async (firebaseUser) => {
      if (!firebaseUser) {
        dispatch(removeCurrentUserAction())
        setIsLoading(false)
        return
      }

      try {
        const result = await verifyAuth()
        const isAdmin = result.data?.auth?.verifyAuth.isAdmin

        if (!isAdmin) {
          dispatch(removeCurrentUserAction())
          await signOut(getAuth())
          alert('You are not authorized to access this application')
        } else {
          dispatch(setCurrentUserAction({email: firebaseUser.email ?? ''}))
        }
      } catch (error) {
        console.error('Authorization check failed:', error)
        dispatch(removeCurrentUserAction())
        await signOut(getAuth())
      } finally {
        setIsLoading(false)
      }
    })

    return () => unsubscribe()
  }, [dispatch, verifyAuth])

  if (isLoading) return <div>Loading...</div>

  return <>{children}</>
}
